<template>
  <AppContainer :is-loading>
    <div>
      <EPageTitleMobile :title="t(useTranslationPath(callerPath, 'title'))" />

      <EForm>
        <EFormField
          id="contractor"
          :label="t(useTranslationPath(callerPath, 'contractorLabel'))"
          :hint="t(useTranslationPath(callerPath, 'contractorHint'))"
          :errors="getFieldErrors(errors, 'contractor')"
        >
          <EAutoComplete
            id="contractor"
            v-model="v$.contractor.$model"
            :on-search="searchContractors"
            name="contractor"
            value-key="id"
            label-key="name"
            :min-query-length="3"
          />
        </EFormField>
      </EForm>
    </div>

    <template #bottom>
      <EButton
        :label="t(useTranslationPath(callerPath, 'next'))"
        block
        :disabled="v$.$invalid || isSubmitting"
        @click="onSubmit"
      />
    </template>
  </AppContainer>
</template>

<script setup>
import AppContainer from '@/components/AppContainer.vue'
import { useApiErrorHandler } from '@/composables/useApiErrorHandler.js'
import { useTranslationPath } from '@/composables/useTranslationPath.js'
import { useAppStore } from '@/stores/AppStore'
import { useUnauthenticatedTokenStore } from '@/stores/unauthenticated/UnauthenticatedTokenStore.js'
import { EAutoComplete, EButton, EForm, EFormField, EPageTitleMobile } from '@expansivefm/eds'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { inject, onMounted, reactive, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const $apiUnauthenticatedRequest = inject('$apiUnauthenticatedRequest')
const router = useRouter()
const unauthenticatedTokenStore = useUnauthenticatedTokenStore()
const appStore = useAppStore()
const { handleErrors, getFieldErrors } = useApiErrorHandler(router)

const callerPath = 'views.unauthenticated.contractor'

const isLoading = ref(null)
const errors = ref([])
const isSubmitting = ref(false)

const form = reactive({
  contractor: null,
})

const validationRules = {
  contractor: { required },
}

const v$ = useVuelidate(validationRules, form)

onMounted(async () => {
  appStore.$patch({ showBackButton: true })
})

const searchContractors = async (query) => {
  try {
    return await $apiUnauthenticatedRequest
      .index(
        `contractors`,
        $apiUnauthenticatedRequest.configs.index.setSort('name').setFilters({ name: query || '' }),
      )
      .then(({ data }) => {
        return data
      })
  } catch (error) {
    await handleErrors(error)
  }
}

const onSubmit = async () => {
  v$.value.$touch()

  if (v$.value.$invalid) {
    return
  }

  isLoading.value = true
  isSubmitting.value = true

  try {
    await $apiUnauthenticatedRequest.patch(
      'engineer-check-in-access-tokens',
      $apiUnauthenticatedRequest.configs.patch
        .setId(unauthenticatedTokenStore.tokenId)
        .setData({ contractor: form.contractor, user: null }),
    )

    await router.push({
      name: 'auth.user',
    })
  } catch (error) {
    const result = await handleErrors(error)
    errors.value = result.validationErrors
  } finally {
    isLoading.value = false
    isSubmitting.value = false
  }
}
</script>
